import React from 'react';

import { Divider, Row, Col } from 'antd';
import { getFullName } from 'utils/personUtils';
import {
  getContactForLabel,
  getPreferredContactMethodLabel,
} from 'utils/primaryContactUtils';
import { ProfileCorporatePrimaryContactInfoModel } from 'api/backofficeApiClient';

type Props = {
  primaryContact: ProfileCorporatePrimaryContactInfoModel;
};

export default function PrimaryContactCard(props: Props) {
  const { primaryContact } = props;

  const primaryContactName = getFullName(
    primaryContact?.firstName,
    primaryContact?.lastName,
  );
  const preferredContactMethodLabel = getPreferredContactMethodLabel(
    primaryContact?.preferredContactMethod,
  );
  const contactForLabel = getContactForLabel(primaryContact?.contactFor);

  return (
    <div className="divider-box">
      <div className="content-wrapper">
        <Row gutter={[4, 4]} className="titled-sheet">
          {!!primaryContactName && (
            <Col xs={24} md={12}>
              <div className="title">Primary contact:</div>
              <div>{primaryContactName}</div>
            </Col>
          )}

          {!!primaryContact?.title && (
            <Col xs={24} md={12}>
              <div className="title">Title:</div>
              <div>{primaryContact.title}</div>
            </Col>
          )}

          {!!primaryContact?.email && (
            <Col xs={24} md={12}>
              <div className="title">Email:</div>
              <div>{primaryContact.email}</div>
            </Col>
          )}

          {!!primaryContact?.phoneNumber && (
            <Col xs={24} md={12}>
              <div className="title">Phone number:</div>
              <div>{primaryContact.phoneNumber}</div>
            </Col>
          )}

          {!!preferredContactMethodLabel && (
            <Col xs={24} md={12}>
              <div className="title">Preferred contact method:</div>
              <div>{preferredContactMethodLabel}</div>
            </Col>
          )}

          {!!contactForLabel && (
            <Col xs={24} md={12}>
              <div className="title">Contact for:</div>
              <div>{contactForLabel}</div>
            </Col>
          )}
        </Row>
      </div>
      <Divider className="card-divider no-margin" />
    </div>
  );
}
